import Vue from 'vue'
import Router from 'vue-router'
import { deCentralization } from '@/utils'
export const routerView = deCentralization(
    require.context('./', true, /\.\/\w+\/\w+\.js/),
    (a, b) => [...a, ...b]
)
Vue.use(Router)
const router = new Router({
    routes: [...routerView]
})

//  console.log(router)
export default router


// WEBPACK FOOTER //
// ./src/router/index.js